import { useMemo } from 'react';
import { Avatar as AvatarShadcn, AvatarImage } from '@/components/ui/avatar';
import { AnimationShell, Typography } from '@/components';
import { cn } from '@/utils/styles';

export type AvatarProps = {
  readonly firstName: string;
  readonly lastName: string | null;
  readonly fullName: string;
  readonly avatar: string | null;
  readonly size?: 'sm' | 'md' | 'lg';
};

export function Avatar({ firstName, lastName, fullName, avatar, size = 'sm' }: AvatarProps) {
  const firstLetter = useMemo(() => firstName.slice(0, 1).toUpperCase(), [firstName]);
  const secondLetter = useMemo(() => lastName?.slice(0, 1).toUpperCase(), [lastName]);

  const smallSize = size === 'sm';
  const largeSize = size === 'lg';
  const sizeImgLarge = largeSize ? 'h-14 w-14' : 'h-10 w-10';

  return (
    <AnimationShell
      type="scale"
      className={cn(
        'flex shrink-0 items-center justify-center overflow-hidden rounded-full',
        smallSize ? 'h-8 w-8' : sizeImgLarge,
        !avatar ? 'bg-primary-accent': ''
      )}
    >
      {avatar ? (
        <AvatarShadcn className="h-full w-full">
          <AvatarImage src={avatar} alt={fullName} />
        </AvatarShadcn>
      ) : (
        <Typography
          as="span"
          size={smallSize ? 'body-2' : 'title'}
          weight="normal"
          color="white"
          className="tracking-wider uppercase"
        >
          {firstLetter}
          {secondLetter}
        </Typography>
      )}
    </AnimationShell>
  );
}
